import { render, staticRenderFns } from "./SingerList.vue?vue&type=template&id=d6056080&scoped=true"
import script from "./SingerList.vue?vue&type=script&lang=js"
export * from "./SingerList.vue?vue&type=script&lang=js"
import style0 from "./SingerList.vue?vue&type=style&index=0&id=d6056080&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6056080",
  null
  
)

export default component.exports